import { render, staticRenderFns } from "./List.vue?vue&type=template&id=242eae20&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=242eae20&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=242eae20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242eae20",
  null
  
)

export default component.exports